import script from "./ProductViewsInsightModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductViewsInsightModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProductViewsInsightModal.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__